import { ListItem } from "@mui/material"

export function ComponentProblemItem({ item }) {
    return <ListItem data-cy="cannot-apply-component-list-item">{item}</ListItem>
}
